import { FACTURA_EXPORTACION_TYPES } from "../constants/factura-exportacion.types";
import { FacturaExportacion, StateFE, ActionFE } from "../interfaces/factura-exportacion.interface";

const initialState: FacturaExportacion = {
    formCliente: {
        granContribuyente: false,
        fecha: new Date().toISOString().split('T')[0],
        tipoDocumento: '',
        noDocumento: '',
        nombre: '',
        departamento: '',
        municipio: '',
        direccion: '',
        email: '',
        chipsEmail: [],
        telefono: '',
        actividad: '',
        actividadDescripcion: '',
        municipioDescripcion: '',
        departamentoDescripcion: '',
        nrc: '',

        paisExportacion: '',
        recintoFiscal: '',
        regimenExportacion: '',
        incoterms: '',
        seguro: '',
        flete: '',
        persona: '',
        descuentoGlobal: '',
    
        datosSucursal: [],
        datosDocumento: [],
    
        sucursal: '',
        serie:'',
    },

    errorsCliente: {
        granContribuyente: false,
        fecha: '',
        tipoDocumento: '',
        noDocumento: '',
        nombre: '',
        departamento: '',
        municipio: '',
        direccion: '',
        email: '',
        chipsEmail: [],
        telefono: '',
        actividad: '',
        actividadDescripcion: '',
        municipioDescripcion: '',
        departamentoDescripcion: '',
        nrc: '',
    
        datosSucursal: null,
        datosDocumento: null,

        paisExportacion: '',
        recintoFiscal: '',
        regimenExportacion: '',
        incoterms: '',
        seguro: '',
        flete: '',
        persona: '',
        descuentoGlobal: '',
    
        sucursal: '',
        serie:'',
    },

    productos: [],
    formProducto: {
        conIva: false,
        descripcion: '',
        cantidad: '',
        precio: '',
        tipoDescuento: 'Porcentaje',
        descuento: '',
        servicio: false,
        exento: false,
        id: null,
        unidadMedida: '59'
    },

    errorsProducto: {
        conIva: false,
        descripcion: '',
        cantidad: '',
        precio: '',
        tipoDescuento: '',
        descuento: '',
        servicio: false,
        exento: false,
        unidad: ''
    },
    modal_editar: false,
    modal_eliminar: false,
    modal_quitarTodo: false,
    modal_emitir: false,
    modal_emitido: false,
    modal_masOpciones: false,
    modal_enviarCorreo: false,
    modal_imprimir: false,
    modal_anular: false,
    modal_anulado: false,
    modal_clienteEncontrado: false,

    clienteEncontrado: null,
    productoEdit: {
        conIva: false,
        descripcion: '',
        cantidad: '',
        precio: '',
        tipoDescuento: 'Porcentaje',
        descuento: '',
        servicio: false,
        exento: false
    },
    productoIndex: null,

    calculosGenerales: {
        operaciones: '',
        retencionRenta: '',
        iva: '',
        ivaPercibido: '',
        ivaRenetido: '',
    },

    calculosProducto: {
        neto: '',
        subtotal: '',
        descuento: '',
        total: '',
        iva: ''
    },

    view: 'Formularios',
    
    response_Emitir: null,
    response_QRcode: '',
    sucursales: [],
    documentos: [],
    recintos: [],
    regimenes: [],
    inconterms: [],
    formasPago: [],
    paises: [],
    unidades: [],
    blockedData: true,
    tableProductos: [],
    formObservaciones: {
        referencia: '',
        observaciones: '',
        mostrarObservacionesPdf: true,
        incluirObservacionesCorreo: true,
    },
}

const facturaExportacionReducer = (
    state: FacturaExportacion = initialState,
    action: ActionFE
): StateFE => {
    switch (action.type) {
        case FACTURA_EXPORTACION_TYPES.FE_SET_FORM_CLIENTE:
            return {...state, formCliente: action.payload}
        case FACTURA_EXPORTACION_TYPES.FE_SET_FORM_PRODUCTO:
            return {...state, formProducto: action.payload}
        case FACTURA_EXPORTACION_TYPES.FE_HANDLE_ERRORS_CLIENTE:
            return {...state, errorsCliente: action.payload}
        case FACTURA_EXPORTACION_TYPES.FE_HANDLE_ERRORS_PRODUCTO:
            return {...state, errorsProducto: action.payload}
        case FACTURA_EXPORTACION_TYPES.FE_SET_VIEW:
            return {...state, view: action.payload}
        case FACTURA_EXPORTACION_TYPES.FE_SET_PRODUCTOS:
            return {...state, productos: action.payload}
        case FACTURA_EXPORTACION_TYPES.FE_SET_PRODUCTO_EDIT:
            return {...state, productoEdit: action.payload}
        case FACTURA_EXPORTACION_TYPES.FE_SET_PRODUCTO_INDEX:
            return {...state, productoIndex: action.payload}
        case FACTURA_EXPORTACION_TYPES.FE_ACTIVE_MODAL_EDITAR_PRODUCTO:
            return {...state, modal_editar: action.payload}
        case FACTURA_EXPORTACION_TYPES.FE_ACTIVE_MODAL_ELIMINAR_PRODUCTO:
            return {...state, modal_eliminar: action.payload}
        case FACTURA_EXPORTACION_TYPES.FE_ACTIVE_MODAL_QUITAR_TODO:
            return {...state, modal_quitarTodo: action.payload}
        case FACTURA_EXPORTACION_TYPES.FE_ACTIVE_MODAL_EMITIR:
            return {...state, modal_emitir: action.payload}
        case FACTURA_EXPORTACION_TYPES.FE_ACTIVE_MODAL_EMITIDO:
            return {...state, modal_emitido: action.payload}
        case FACTURA_EXPORTACION_TYPES.FE_ACTIVE_MODAL_MAS_OPCIONES:
            return {...state, modal_masOpciones: action.payload}
        case FACTURA_EXPORTACION_TYPES.FE_ACTIVE_MODAL_ENVIAR_CORREO:
            return {...state, modal_enviarCorreo: action.payload}
        case FACTURA_EXPORTACION_TYPES.FE_ACTIVE_MODAL_ANULAR:
            return {...state, modal_anular: action.payload}
        case FACTURA_EXPORTACION_TYPES.FE_ACTIVE_MODAL_ANULADO:
            return {...state, modal_anulado: action.payload}
        case FACTURA_EXPORTACION_TYPES.FE_ACTIVE_MODAL_IMPRIMIR:
            return {...state, modal_imprimir: action.payload}
        case FACTURA_EXPORTACION_TYPES.FE_SET_CALCULOS_GENERALES:
            return {...state, calculosGenerales: action.payload}
        case FACTURA_EXPORTACION_TYPES.FE_RESTART_FORM_PRODUCTO:
            return {...state, formProducto: initialState.formProducto}
        case FACTURA_EXPORTACION_TYPES.FE_SET_QR_CODE:
            return {...state, response_QRcode: action.payload}
        case FACTURA_EXPORTACION_TYPES.FE_SET_RESPONSE_EMITIR:
            return {...state, response_Emitir: action.payload}
        case FACTURA_EXPORTACION_TYPES.FE_SET_CLIENTE_ENCONTRADO:
            return {...state, clienteEncontrado: action.payload}
        case FACTURA_EXPORTACION_TYPES.FE_ACTIVE_MODAL_CLIENTE_ENCONTRADO:
            return {...state, modal_clienteEncontrado: action.payload}
        case FACTURA_EXPORTACION_TYPES.FE_SET_CALCULOS_PRODUCTO:
            return {...state, calculosProducto: action.payload}
        case FACTURA_EXPORTACION_TYPES.FE_SET_FORMAS_PAGO:
            return {...state, formasPago: action.payload}
        case FACTURA_EXPORTACION_TYPES.FE_SET_INCOTERMS:
            return {...state, inconterms: action.payload}
        case FACTURA_EXPORTACION_TYPES.FE_SET_RECINTOS:
            return {...state, recintos: action.payload}
        case FACTURA_EXPORTACION_TYPES.FE_SET_REGIMENES:
            return {...state, regimenes: action.payload}
        case FACTURA_EXPORTACION_TYPES.FE_SET_PAISES:
            return {...state, paises: action.payload}
        case FACTURA_EXPORTACION_TYPES.FE_SET_UNIDADES:
            return {...state, unidades: action.payload}
        case FACTURA_EXPORTACION_TYPES.FE_SET_BLOCKED_DATA:
            return {...state, blockedData: action.payload}
        case FACTURA_EXPORTACION_TYPES.FE_SET_TABLE_PRODUCTOS:
            return {...state, tableProductos: action.payload}
        case FACTURA_EXPORTACION_TYPES.FE_FORMOBSERVACIONES_HANDLE_CHANGE:
            return {...state, formObservaciones: {...state.formObservaciones, ...action.payload}}
        case FACTURA_EXPORTACION_TYPES.FE_RESTART_ALL:
            return {...initialState, productos: [], inconterms: state.inconterms, recintos: state.recintos, regimenes: state.regimenes, formasPago: state.formasPago, paises: state.paises, unidades: state.unidades}
        default:
            return state;
    }
}

export default facturaExportacionReducer;